import { render } from "./BstkCSVToggleHeaders.vue?vue&type=template&id=56afd458"
import script from "./BstkCSVToggleHeaders.vue?vue&type=script&lang=js"
export * from "./BstkCSVToggleHeaders.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/alarm-receiver-frontend/alarm-receiver-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__